export const REALTIME_ROUTES = {
  CALL: '/voice-companion/call/',
  REGISTER_CALL: '/voice-companion/register-call/',
};

// There is no non-backend URL in this app any more.
//
// The browser used to POST its SDP offer straight to
// `https://api.openai.com/v1/realtime/calls` signed with an ephemeral `ek_…`.
// That call works — audio flows — but it can never be attached to from the
// server: every `wss://api.openai.com/v1/realtime?call_id=…` handshake answers
// `404 call_id_not_found`, whichever credential the sideband presents, because
// the call was created with an ephemeral key. Only a call created with the
// standard API key can be attached to, and that key must never reach a browser,
// so the SDP exchange goes through `REALTIME_ROUTES.CALL` instead.
